export const blockIconsActionLogin = (
	<span className='material-symbols-outlined'>login</span>
);
